/**
 * 商品一覧ページ切り替え時のY座標を返す
 */
export const getDestinationPointY = (offsetY = 80) => {
	let positionY = null;
	let chk = document.getElementById('Search-Excerpt-Detail');
	if (0 === chk.getBoundingClientRect().width) {
		let rect = document
			.getElementById('Search-Excerpts')
			.getBoundingClientRect();
		positionY = rect.top + pageYOffset - offsetY;
	}
	return positionY;
};
